import { render } from "./AyudaPersonaForm.vue?vue&type=template&id=0b8ee9e6&scoped=true"
import script from "./AyudaPersonaForm.vue?vue&type=script&lang=js"
export * from "./AyudaPersonaForm.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=0b8ee9e6&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8ee9e6"]])

export default __exports__